import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { Arbitro } from '../../system/Arbitro/Arbitro';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
interface IArbitroSelector {
  system: SystemClient;
  courier: MessageCourier;
  selectedKey: string;
  onSelect: (a: Arbitro) => void;
  providedList?: Arbitro[];
}

export const ArbitroSelector = (props: IArbitroSelector) => {
  const arbitros = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getArbitroSystem().getListForDropdown(),
    [props.providedList],
    props.courier
  );
  const arbitroOptions = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (arbitros) {
      ret = arbitros.map((entity: Arbitro) => {
        return { key: entity.getId()!, text: `${entity.getNombre()} ${entity.getApellido()}`, data: entity };
      });
    }

    return ret;
  }, [arbitros]);

  const onSelect = (opt: IComboBoxOption) => {
    const a = arbitros?.find((a) => a.isIdentifiedBy(String(opt.key)));
    if (a) props.onSelect(a);
  };

  React.useEffect(() => {
    console.log('cambio >  ', props.selectedKey);
  }, [props.selectedKey]);

  return (
    <ComboBoxSearch
      selected={[props.selectedKey]}
      options={arbitroOptions}
      onSelectOption={onSelect}
    ></ComboBoxSearch>
  );
};

interface IArbitroSelectorInput {
  system: SystemClient;
  courier: MessageCourier;
  input: CustomInputIfc;
  hideLabel?: boolean;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  providedList?: Arbitro[];
  onChangeExtended?: (a: Arbitro) => void;
  onDelete?: () => void;
}

export const ArbitroSelectorInput = (props: IArbitroSelectorInput) => {
  const { t, i18n } = useTranslation();
  const [currentArbitro, setCurrentArbitro] = React.useState<Arbitro | undefined>(undefined);
  const [arbitroOptions, setArbitroOptions] = React.useState<IComboBoxOption[]>([]);
  const arbitros = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getArbitroSystem().getListForDropdown(),
    [props.providedList],
    props.courier
  );
  const mapArbitroOptions = (arbitros: Arbitro[]) => {
    const opciones = arbitros.map((entity: Arbitro) => {
      return { key: entity.getId()!, text: `${entity.getNombre()} ${entity.getApellido()}`, data: entity };
    });
    setArbitroOptions(opciones);
  };
  const selectDefaultArbitro = (id: string) => {
    setCurrentArbitro(arbitros ? arbitros.find((entity: Arbitro) => entity.getId() === id) : undefined);
  };
  const forceUpdate = useForceUpdate();

  React.useEffect(() => {
    forceUpdate();
  }, [currentArbitro]);

  const onChangeExtended = () => {
    const _categoria = arbitros?.find((c) => c.getId() === props.input.getValue());
    if (_categoria && props.onChangeExtended) {
      props.onChangeExtended(_categoria);
    }
  };

  React.useEffect(() => {
    selectDefaultArbitro(props.input.getValue());
    mapArbitroOptions(arbitros ? arbitros : []);
  }, [arbitros, currentArbitro]);

  return (
    <>
      {arbitros && (
        <ComboBoxInput
          input={props.input}
          label={props.hideLabel ? '' : t('Arbitro')}
          onBlur={props.onBlurCustomInput}
          options={arbitroOptions ? arbitroOptions : []}
          onChangeExtended={onChangeExtended}
          selectedKey={props.input.getValue()}
          onDelete={props.onDelete}
        />
      )}
    </>
  );
};
